import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import appStore from '../../assets/app_store.svg';
import playStore from '../../assets/google_play.svg';
import PhoneMockup from '../phone/PhoneMockup';
import './ProductPage.css';

const StoreButtons = ({product, t}) => (
    <div className="store-buttons">
        <a
            href={product.appStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${t(product.nameKey)} ${t('store.app_store')}`}
        >
            <img src={appStore} alt={t('store.app_store')}/>
        </a>
        <a
            href={product.playStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${t(product.nameKey)} ${t('store.google_play')}`}
        >
            <img src={playStore} alt={t('store.google_play')}/>
        </a>
    </div>
);

const ProductPage = ({product}) => {
    const {t, i18n} = useTranslation();
    const lang = i18n.language.startsWith('ko') ? 'ko' : 'en';
    const accentStyle = {'--accent': product.accent};

    return (
        <div className="product-page" style={accentStyle}>
            <header className="product-hero container">
                <img className="product-hero-icon" src={product.icon} alt=""/>
                <h1>{t(product.nameKey)}</h1>
                <p className="product-hero-tagline">{t(product.taglineKey)}</p>
                <p className="product-hero-intro">{t(product.introKey)}</p>
                <StoreButtons product={product} t={t}/>
                <p className="product-hero-note">{t('p.platform_note')}</p>

                <div className="product-hero-screen">
                    <PhoneMockup
                        src={product.heroScreen[lang]}
                        alt={t(product.heroAltKey)}
                        loading="eager"
                    />
                </div>
            </header>

            <section className="product-features container" aria-label={t('p.features_label')}>
                {product.features.map((feature, index) => (
                    <div
                        className={`feature-row${index % 2 === 1 ? ' reverse' : ''}`}
                        key={feature.key}
                    >
                        <div className="feature-copy">
                            <h2>{t(`${feature.key}.title`)}</h2>
                            <p>{t(`${feature.key}.body`)}</p>
                        </div>
                        <div className="feature-screen">
                            <PhoneMockup
                                src={feature.screen[lang]}
                                alt={t(`${feature.key}.title`)}
                            />
                        </div>
                    </div>
                ))}
            </section>

            <section className="product-extras">
                <div className="container extras-inner">
                    <div className="extras-copy">
                        <h2>{t(`${product.extrasKey}.title`)}</h2>
                        <ul className="extras-list">
                            {[1, 2, 3, 4].map((n) => (
                                <li key={n}>
                                    <strong>{t(`${product.extrasKey}.i${n}.title`)}</strong>
                                    <span>{t(`${product.extrasKey}.i${n}.body`)}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="extras-screens">
                        {product.gallery.map((item) => (
                            <figure className="extras-shot" key={item.key}>
                                <PhoneMockup src={item.screen[lang]} alt={t(item.key)}/>
                                <figcaption>{t(item.key)}</figcaption>
                            </figure>
                        ))}
                    </div>
                </div>
            </section>

            <section className="product-download container">
                <h2>{t('p.download.title')}</h2>
                <StoreButtons product={product} t={t}/>
                <p className="product-privacy-note">
                    {t(product.privacyNoteKey)}{' '}
                    <Link className="text-link" to={product.privacyPath}>
                        {t('p.privacy_link')}
                        <span className="arrow" aria-hidden="true">→</span>
                    </Link>
                </p>
            </section>
        </div>
    );
};

export default ProductPage;
